<div class="command-spinner">
  <div [style.visibility]="isLoading() ? 'hidden' : 'inherit'">
    <ng-content></ng-content>
  </div>

  <div class="command-spinner-progress"
       [@control-animation]="isLoading()"
       [hidden]="!isLoading()">
    <div class="my-auto d-flex h-100 align-items-center"
         [class.flex-column]="!small()"
         [class.justify-content-center]="!small()"
         [class.flex-row-reverse]="reverse()">
      <div class="progress"
           style="position: absolute; left: 0; bottom: 0; right: 0">
        <div class="progress-bar"
             role="progressbar"
             [style.width]="status() + '%'"
             [attr.aria-valuenow]="status()"
             aria-valuemin="0"
             aria-valuemax="100">
          {{ status() }}%
        </div>
      </div>

      <ml-sk-spinner-3 class="compact"
                       [hidden]="!isLoading()"></ml-sk-spinner-3>

      <div class="status w-100"
           [class.h-100]="small()">
        <div class="h-100"></div>
        <div>
          <p class="small text-primary not-now"
             [@text-animation]="direction()"
             i18n>Uploading</p>
        </div>
      </div>
    </div>
  </div>
</div>